import { render, staticRenderFns } from "./BesoinTravail.vue?vue&type=template&id=6152023d&"
import script from "./BesoinTravail.vue?vue&type=script&lang=js&"
export * from "./BesoinTravail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports